import { render, staticRenderFns } from "./DetalleEstadoAcuerdoComercial.vue?vue&type=template&id=a825b5c0"
import script from "./DetalleEstadoAcuerdoComercial.vue?vue&type=script&lang=js"
export * from "./DetalleEstadoAcuerdoComercial.vue?vue&type=script&lang=js"
import style0 from "./DetalleEstadoAcuerdoComercial.vue?vue&type=style&index=0&id=a825b5c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
